exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bounce-enter-active{animation:bounce-in .5s}.bounce-leave-active{animation:bounce-in .5s reverse}@keyframes bounce-in{0%{transform:scale(0)}50%{transform:scale(1.5)}to{transform:scale(1)}}.mail-btn{margin:1rem}.alert{text-align:center;position:absolute;width:100%;top:2rem}.mail_spinner{float:right}.contacts_left_block{text-align:center}.contacts_left_block>span{display:block;margin-bottom:1rem}.contacts_left_block:last-child{max-width:80%;margin-left:10%}.ttt{display:flex;align-items:center;height:90vh}.prices_container>h5{text-align:center}.mail_block{position:relative}.mail_block>button{float:right}.mail_block>input{margin-bottom:1rem}.mail_block>label{margin-bottom:.2rem!important}.mail_block>textarea{margin-bottom:1rem}@media (max-width:767px){.mail_block{margin-bottom:3rem}.alert{position:absolute;z-index:999;top:15vh;left:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27aeb6fe","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Contacts.vue
// module id = 319
// module chunks = 0